export default {
    invalid_title: "Cupón {0} no es válido",
    utilizing_title: "Utilizando cupón {0}",
    error_expired: "Cupón expiró",
    error_not_yet_valid: "El cupón será válido a partir de",
    error_used: "Cupón ya utilizado",
    error_not_found: "Código no encontrado",
    benefit_prefix: "Conceder el beneficio de",
    irreversible: "Esta acción é irreversible.",
    purchase_value_label:
        "¿Cuál es el valor de la compra que el cliente está realizando?",
    order_value_placeholder: "Valor del pedido",
    min_value_error: "El valor debe ser superior a R${0}",
    discount_label: "Descuento: R${0}",
    close_button: "Cerrar",
    confirm_button: "Confirmar uso",
    used_title: "Cupón {0} fue utilizado",
    used_success: "El cupón de {0} se utilizó con éxito.",
    used_invalid_now: "El cupón {0} ya no es válido",
    generic_error: "Algo salió mal, por favor inténtelo de nuevo más tarde",
    incentive_text_label: "Texto del incentivo",
    probability_label: "Probabilidad",
    name_locked_tooltip:
        "Este cupón ya tiene códigos generados y no se puede eliminar ni cambiar su nombre.",
    generated_singular: "generado",
    generated_plural: "generados",
    conjunction_and: "y",
    used_singular: "canjeado",
    used_plural: "canjeados",
    delete_coupon: "Eliminar cupón",
    remove_notice: "El cupón {0} se eliminará al guardar.",
    undo: "Deshacer",
    empty_prefix: "Todavía no tienes ningún cupón,",
    empty_cta: "¡crea el primero ahora!",
    new_coupon: "Nuevo cupón",
    registered_coupons: "Cupones registrados",
    total_probability_error:
        "La suma de las probabilidades debe ser 100 pero actualmente es {0}",
    saved_success: "Guardado con éxito",
    save_button: "Guardar",
    page_title: "Kevi | Cupones",
};
